import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router/index'
import ElementPlus from 'element-plus'
import zhElementPlus from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import PageTitle from './components/PageTitle.vue'

const app = createApp(App)
app.use(router)
app.use(ElementPlus, { locale: zhElementPlus })
// 页面标题组件全局注册，各页面直接写 <page-title>
app.component('PageTitle', PageTitle)
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}